'use client';

// Package Imports
import React from 'react';

// Type Imports
import type { WithContext, Thing } from 'schema-dts';

interface SchemaProps<T extends Thing> {
  data: WithContext<T>;
}

const JsonLdSchema = <T extends Thing>({ data }: SchemaProps<T>) => {
  return <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
};

export default JsonLdSchema;
